import { stringify } from 'query-string';
import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';
import type { VersionsResponse } from './types.tsx';

export const MAX_RESULTS = 5;

export const getVersionsEndpointUrl = (projectKey: string): string =>
	`/rest/api/2/project/${projectKey}/version`;

export const getVersionsUrlParams = (
	filter: string,
	versionStatuses: string[],
	ignore: string[],
): string =>
	stringify({
		startAt: 0,
		query: filter,
		maxResults: MAX_RESULTS + ignore.length,
		orderBy: '+NAME',
		status: versionStatuses.join(','),
	});

export const getVersionsRetrieveUrl = (
	projectKey: string,
	filter: string,
	versionStatuses: string[],
	ignore: string[],
): string =>
	`${getVersionsEndpointUrl(projectKey)}?${getVersionsUrlParams(filter, versionStatuses, ignore)}`;

type RequestVersions = (
	projectKey: string,
	filter: string,
	versionStatuses: string[],
	ignore: string[],
) => Promise<VersionsResponse>;

export const requestVersions: RequestVersions = async (
	projectKey,
	filter,
	versionStatuses,
	ignore,
) => fetchJson(getVersionsRetrieveUrl(projectKey, filter, versionStatuses, ignore));
